// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'reply';

export const Component = () => (
  <path d='m1.456 10.775 6.741 6.337v-4.114h.956c2.2 0 4.637.662 7.363 1.939a19.384 19.384 0 0 1 6.836 5.39c-.526-3.451-2.103-6.336-4.733-8.652-2.63-2.317-5.736-3.452-9.275-3.452H8.197V4.11l-6.74 6.667v-.002Zm-.669-.662 7.554-7.471c.19-.095.287-.142.334-.142.335 0 .478.189.478.52v4.255c4.016 0 7.506 1.324 10.518 4.02 2.964 2.647 4.59 6.194 4.829 10.685 0 .331-.143.52-.43.52a.506.506 0 0 1-.431-.236c-1.674-2.506-3.92-4.54-6.741-6.052-2.868-1.56-5.45-2.317-7.745-2.317v4.303c0 .33-.143.472-.478.472-.143 0-.287-.047-.334-.094l-7.554-7.14C.596 11.246.5 11.058.5 10.82a.96.96 0 0 1 .287-.71v.002Z' />
);

export const viewBox = '0 0 25 25';
